/** Risk time-term codes mapped to Norwegian labels. */
export const riskTimeTermsNb: Record<string, string> = {
  short: "Kort sikt",
  medium: "Mellomlang sikt",
  long: "Lang sikt",
}

/** Sorted array of { code, name } for use in dropdowns. */
export const riskTimeTermOptionsNb: Array<{ code: string; name: string }> = Object.entries(riskTimeTermsNb).map(
  ([code, name]) => ({
    code,
    name,
  }),
)
